/**
 * <ModalContent />
 *
 * @parent Modal
 * @stateless
 */
import React, { PropTypes } from 'react';
import {
  Button,
	PanelWrapper,
	Tab,
	Tabs,
	TabList,
	TabPanel
} from 'components/UI'

import DefaultTab from './DefaultTab'
import locale from './locale'
import './Modal.scss';

class ModalContent extends React.Component {
  constructor(props){
    super(props)

    this.state = {
      selectedIndex: 0
    }

    this.onTabSelected = this.onTabSelected.bind(this)
  }

  onTabSelected(selectedIndex){
    this.setState({selectedIndex: selectedIndex})

  }

  render() {
    const {selectedIndex} = this.state
    return (
        <PanelWrapper className='media-center-content'>
          <Tabs selectedIndex={selectedIndex} onSelect={this.onTabSelected}>
            <TabList>
              <Tab>{__('Upload Files', locale)}</Tab>
              <Tab>{__('Media Library', locale)}</Tab>
              <Tab>{__('Public Media Library', locale)}</Tab>
            </TabList>

            <TabPanel>
              <DefaultTab
                mediaState={'upload'}
                selectMultiple={this.props.selectMultiple}
                selectedIndexChange={this.onTabSelected}
                onFormChange={this.props.onFormChange}
               />
            </TabPanel>
            <TabPanel>
              <DefaultTab
                mediaState={'list'}
                selectMultiple={this.props.selectMultiple}
                selectedIndexChange={this.onTabSelected}
                onFormChange={this.props.onFormChange}
               />
            </TabPanel>
            <TabPanel>
              <DefaultTab
                mediaState={'public'}
                selectMultiple={this.props.selectMultiple}
                selectedIndexChange={this.onTabSelected}
                onFormChange={this.props.onFormChange}
               />
            </TabPanel>
          </Tabs>
        </PanelWrapper>
    )
  }
}

export default ModalContent;



// WEBPACK FOOTER //
// ./src/template/Modals/MediaCenter/ModalContent.js